import { useContext, useEffect, useState } from 'react';
import { DATO_A_EXPORTAR, TIPO_REPORTE } from './helpers/Texts';
import { PERMISOS } from 'const/Permisos';
import { AuthContext } from 'context';
import { useCargarServicio } from 'hooks/useCargarServicio';
import { DICTONARY } from 'const/Dictonary';
import empresasService from 'services/empresas';
import URLS from 'URLS';
import useDispatchAlert from 'utils/useDispatchAlert';
import { descargarArchivo } from 'utils/DescargarArchivos';
import { format } from 'date-fns';

export const useDescargarReporte = () => {
  const {
    perfiles: { isSuperAdmin },
    sucursalNoAdministrada,
    isTienePermisos,
    token
  } = useContext(AuthContext);

  const { data: grupos, cargar: cargarGrupos } = useCargarServicio();
  const {
    data: negocios,
    setData: setNegocios,
    cargar: cargarNegocios
  } = useCargarServicio();
  const {
    data: sucursales,
    cargar: cargarSucursales,
    setData: setSucursales
  } = useCargarServicio();
  const { dispatchAlert } = useDispatchAlert();

  const cargarConfiguracion = () => {
    return {
      [TIPO_REPORTE.PERSONALIZADO]: {
        datoExportar: true,
        [DATO_A_EXPORTAR.USUARIO]: {
          formato: true,
          fechas: false,
          negocios:
            isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
          sucursales: true,
          grupo:
            isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
          periodo: false,
          calendario: false
        },
        [DATO_A_EXPORTAR.RESIDUO]: {
          formato: true,
          fechas: true,
          negocios:
            isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
          sucursales: true,
          grupo:
            isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
          periodo: false,
          calendario: false
        },
        [DATO_A_EXPORTAR.INDICADOR]: {
          formato: true,
          fechas: false,
          negocios: isTienePermisos(PERMISOS.administracionSucursales),
          sucursales: false,
          grupo: false,
          periodo: false,
          calendario: false
        },
        [DATO_A_EXPORTAR.RESIDUO_DECLARADO]: {
          formato: true,
          fechas: true,
          negocios:
            isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
          sucursales: true,
          grupo:
            isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
          periodo: false,
          calendario: false
        },
        [DATO_A_EXPORTAR.RECURSO_ADQUIRIDO]: {
          formato: true,
          fechas: true,
          negocios:
            isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
          sucursales: true,
          grupo:
            isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
          periodo: false,
          calendario: false
        }
      },

      [TIPO_REPORTE.COMPLETO]: {
        datoExportar: true,
        [DATO_A_EXPORTAR.USUARIO]: {
          formato: true,
          fechas: false,
          negocios: false,
          sucursales: false,
          grupo: false,
          periodo: false,
          calendario: false
        },
        [DATO_A_EXPORTAR.RESIDUO]: {
          formato: true,
          fechas: true,
          negocios: false,
          sucursales: false,
          grupo: false,
          periodo: false,
          calendario: false
        },
        [DATO_A_EXPORTAR.INDICADOR]: {
          formato: true,
          fechas: true,
          negocios: false,
          sucursales: false,
          grupo: false,
          periodo: false,
          calendario: false
        },
        [DATO_A_EXPORTAR.RESIDUO_DECLARADO]: {
          formato: true,
          fechas: true,
          negocios: false,
          sucursales: false,
          grupo: false,
          periodo: false,
          calendario: false
        },
        [DATO_A_EXPORTAR.RECURSO_ADQUIRIDO]: {
          formato: true,
          fechas: true,
          negocios: false,
          sucursales: false,
          grupo: false,
          periodo: false,
          calendario: false
        }
      },
      [TIPO_REPORTE.SINADER]: {
        periodo: true,
        calendario: true,
        negocios:
          isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
        sucursales: false,
        grupo:
          isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin,
        formato: false,
        fechas: false
      }
    };
  };

  const iniciarFormulario = async () => {
    setCargandoConfiguracion(true);
    try {
      setConfiguracion(cargarConfiguracion());
      if (isTienePermisos(PERMISOS.administracionSucursales) || isSuperAdmin) {
        await cargarGrupos(empresasService.obtenerListaGrupos, {});
      }

      if (isTienePermisos(PERMISOS.administracionSucursales)) {
        let querySucursales = {
          codigoEmpresa: isSuperAdmin
            ? ''
            : sucursalNoAdministrada.sucursal?.empresa?.codigoEmpresa,
          totalPagina: DICTONARY.PAGINACION.ALL_DATA,
          asociados: !isSuperAdmin
        };
        await cargarNegocios(
          empresasService.obtenerListaEmpresas,
          querySucursales
        );
      } else {
        //Si no administra negocios solo cargamos sucursales.
        await cargarSucursales(empresasService.obtieneSucursales, {
          totalPagina: DICTONARY.PAGINACION.ALL_DATA
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCargandoConfiguracion(false);
    }
  };

  const recargarSucursales = async empresas => {
    try {
      if (!empresas) return;

      const sucursales = [];
      const obtenerSucursales = async empresa => {
        const servicio = isTienePermisos(PERMISOS.administracionSucursales)
          ? empresasService.obtenerListaSucursales
          : empresasService.obtieneSucursales;

        const request = await servicio({
          codigoEmpresa: empresa.codigoEmpresa,
          totalPagina: DICTONARY.PAGINACION.ALL_DATA
        });

        return isTienePermisos(PERMISOS.administracionSucursales)
          ? request.data
          : request.data.content;
      };

      const empresasAux = Array.isArray(empresas) ? empresas : [empresas];
      const resultados = await Promise.all(empresasAux.map(obtenerSucursales));
      resultados.forEach(sucursal => sucursales.push(...sucursal));

      setSucursales(sucursales);
    } catch (error) {
      console.log(error);
    }
  };

  const desplegarComponente = (
    tipoReporte,
    datoAExportar,
    atributoParaValidar
  ) => {
    try {
      //Esta validación es necesaria ya que el REPORTE SINADER no contiene datos a exportar
      if (datoAExportar === null || tipoReporte === TIPO_REPORTE.SINADER) {
        return configuracion[tipoReporte][atributoParaValidar];
      }
      return configuracion[tipoReporte][datoAExportar][atributoParaValidar];
    } catch (error) {
      return false;
    }
  };

  const recargarNegocios = async grupos => {
    try {
      if (!grupos) {
        //Recargo todos los negocios cuando se han eliminado los grupos
        if (isTienePermisos(PERMISOS.administracionSucursales)) {
          let querySucursales = {
            codigoEmpresa: isSuperAdmin
              ? ''
              : sucursalNoAdministrada.sucursal?.empresa?.codigoEmpresa,
            totalPagina: DICTONARY.PAGINACION.ALL_DATA,
            asociados: !isSuperAdmin
          };
          await cargarNegocios(
            empresasService.obtenerListaEmpresas,
            querySucursales
          );
          return;
        }
      }

      let querySucursales = {
        asociados: !isSuperAdmin,
        codigoGrupo: grupos.codigoGrupo
      };
      const response = await empresasService.obtenerListaEmpresas(
        querySucursales
      );
      if (response.data) {
        setNegocios(response.data);
      }
    } catch (error) {
      console.log(error);
      setNegocios([]);
    }
  };

  const generateUrl = (values, config) => {
    if (!config[values.tipo]) {
      throw new Error('Tipo de reporte no válido');
    }

    const getBaseUrl = () => URLS.baseURL.replace(/\/$/, '');
    let baseUrl;
    if (values.tipo === 'sinader') {
      baseUrl = `${getBaseUrl()}/empresas/exportar-archivo/sinader`;
    } else {
      if (values.tipoExportacion === DATO_A_EXPORTAR.RESIDUO) {
        baseUrl = `${getBaseUrl()}/residuos/exportar-archivo`;
      } else if (values.tipoExportacion === DATO_A_EXPORTAR.USUARIO) {
        baseUrl = `${getBaseUrl()}/usuarios/exportar-archivo`;
      } else if (values.tipoExportacion === DATO_A_EXPORTAR.INDICADOR) {
        baseUrl = `${getBaseUrl()}/indicadores/exportar-archivo`;
      } else if (values.tipoExportacion === DATO_A_EXPORTAR.RESIDUO_DECLARADO) {
        baseUrl = `${getBaseUrl()}/residuos-declarados/exportar-archivo`;
      } else if (values.tipoExportacion === DATO_A_EXPORTAR.RECURSO_ADQUIRIDO) {
        baseUrl = `${getBaseUrl()}/recursos-adquiridos/exportar-archivo`;
      } else {
        return;
      }
    }

    const params = new URLSearchParams();
    const configSeleccionada =
      values.tipo === 'sinader'
        ? config[values.tipo]
        : config[values.tipo][values.tipoExportacion];

    if (configSeleccionada.formato) {
      if (values.formato) {
        params.append('formato', values.formato);
      }
    }

    if (configSeleccionada.fechas) {
      if (
        values.fechaDisponibilidadInicio_str &&
        values.fechaDisponibilidadTermino_str
      ) {
        params.append('fechaInicio', values.fechaDisponibilidadInicio_str);
        params.append('fechaTermino', values.fechaDisponibilidadTermino_str);
      } else if (values.fechaDisponibilidadInicio_str) {
        params.append('fechaInicio', values.fechaDisponibilidadInicio_str);
      }
    }

    if (configSeleccionada.periodo) {
      if (values.periodo === 'anual') {
        if (values.anyo) {
          params.append('anyo', format(values.anyo, 'yyyy'));
        }
      }
      if (values.periodo === 'mensual') {
        if (values.mesAnyo) {
          params.append('mesAnyo', format(values.mesAnyo, 'MM-yyyy'));
        }
      }
    }

    if (values.sucursales?.length > 0) {
      if (configSeleccionada.sucursales) {
        values.sucursales.forEach(sucursal => {
          params.append('codigoSucursal', sucursal.codigoSucursal);
        });
      }
    } else if (values.negocios?.length > 0) {
      if (configSeleccionada.negocios) {
        values.negocios.forEach(negocio => {
          params.append('codigoEmpresa', negocio.codigoEmpresa);
        });
      }
    } else if (values.grupo && Object.keys(values.grupo).length > 0) {
      if (configSeleccionada.grupo) {
        params.append('codigoGrupo', values.grupo.codigoGrupo);
      }
    }

    return `${baseUrl}?${params.toString()}`;
  };

  const handleSubmit = async values => {
    const requestUrl = generateUrl(values, configuracion);
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    try {
      const response = await fetch(requestUrl, options);
      let data;

      try {
        data = await response.clone().json();
        if (data.error) {
          const codigo = data.error.codigo;
          dispatchAlert(codigo);
          throw new Error('ERROR_SIN_DATOS');
        }
      } catch (error) {
        if (error.message === 'ERROR_SIN_DATOS') {
          throw new Error('ERROR_SIN_DATOS');
        }
      }

      const blob = await response.blob();
      if (blob) {
        const filename = `EXPORTAR_${values.tipoExportacion?.toUpperCase()}_${format(
          new Date(),
          'yyyyMMddHHmmss'
        )}.${values.formato}`;

        descargarArchivo(blob, filename);
      }
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  };

  const [isCargandoConfiguracion, setCargandoConfiguracion] = useState(true);
  const [configuracion, setConfiguracion] = useState(cargarConfiguracion());

  useEffect(() => {
    iniciarFormulario();
  }, []);

  return {
    configuracion,
    setConfiguracion,
    desplegarComponente,
    grupos,
    isCargandoConfiguracion,
    negocios,
    sucursales,
    handleSubmit,

    //Side-effects
    recargarSucursales,
    recargarNegocios
  };
};
